module.exports = __webpack_public_path__ + "static/media/twint_logo.806b8f4e.png";